import { SuchePersonenResponse } from '../types';
import { suche } from '../shared/url';
import { api } from '../apigateway';

export async function sucheNachPersonen(suchbegriffe: string, mandant: string, personenTyp: string): Promise<SuchePersonenResponse> {
  const query = {
    suchbegriff: suchbegriffe,
    mandant,
    typ: personenTyp
  };

  return await api.request(suche.personen(query));
}
